import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { db } from '../../firebase'; // Firebase config
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';

function FranchiseFrom() {
  const [formData, setFormData] = useState({
    name: '',
    city: '',
    mobile: '',
    email: '',
    officearea: ''
  });

  const handleChange = (e) => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await addDoc(collection(db, "FranachieContact"), {
        ...formData,
        createdAt: serverTimestamp()
      });
       alert("Message sent!");
      setFormData({ name: '', city: '', mobile: '', email: '', officearea: '' });
    } catch (err) {
      alert("Error saving data: " + err.message);
    }
  };
const navigate = useNavigate();
  return (
    <form onSubmit={handleSubmit}>
       
      <input className='me-2 ' name="name" onChange={handleChange} value={formData.name} placeholder="Name" required />
      <input className='me-2 mt-2' name="mobile" onChange={handleChange} value={formData.mobile} placeholder="Mobile No." required />
      <input className='me-2 mt-2' name="city" onChange={handleChange} value={formData.city} placeholder="City" required />
            <input className='me-2 mt-2' name="email" onChange={handleChange} value={formData.email} placeholder="Email" required />

      <textarea className='me-2 mt-2' name="officearea" onChange={handleChange} value={formData.officearea} placeholder="Enter office area in sq. ft." required />
      <center>
        <button className='submitpage mt-1' type="submit">Submit</button>
      </center>
     
    </form>
  );
}

export default FranchiseFrom;
